import { render, staticRenderFns } from "./mergeNav.vue?vue&type=template&id=7bcfd636"
import script from "./mergeNav.vue?vue&type=script&lang=js"
export * from "./mergeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports